import { Injectable } from '@angular/core';
import { BaseServiceClient } from '../../../../../../shared/data/src/lib/client/base-service-client';

@Injectable({
    providedIn: 'root',
})
export class ContentHubServiceClientService extends BaseServiceClient {}
